import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';

@Component({
  selector: 'app-exam-schedule-paused-time-log',
  templateUrl: './exam-schedule-paused-time-log.component.html',
  styleUrls: ['./exam-schedule-paused-time-log.component.scss']
})
export class ExamSchedulePausedTimeLogComponent implements OnInit {

  gridName = 'examSchedulePausedTimeLogGrid';
  constructor(private examSchService: ExamScheduleService, private eventService: EventService) {

  }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    this.refreshData();
  }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examScheduleID',
          fieldValue: `${this.examSchService.selectedIds}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'ExamSchedule ID',
      fieldName: 'examScheduleID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Paused Start Date Time',
      fieldName: 'pausedStartDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Paused End Date Time',
      fieldName: 'pausedEndDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Reason',
      fieldName: 'reason',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Origin',
      fieldName: 'origin',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'PausedBy',
      fieldName: 'pausedBy',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'UnpausedBy',
      fieldName: 'unpausedBy',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    }
  ];

  onRowClick(idx: any) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.onRowClick(idx), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedScheduleFlag: any[] = idx.map(x => this.data.tableRows[x]).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedScheduleFlag.map(x => x.id);
    GridUtil.setRowCliclk(this.gridName, idx, selectedDataRowsId);
  }

  async refreshData() {
    const res = await this.examSchService.getExaminationSchedulesPausedTimeLog(this.data.tableParams) as [];
    if (!res || res.length === 0) {
      return;
    }
    this.data.tableRows = res.slice(1, res.length);
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

}
